import { RefObject, useEffect, useRef } from "react";

/**
 * Opening the inline editor unmounts the control that triggered it, so when the editor closes the focus
 * would otherwise fall to <body>. Returns a ref for the element (or its `focusSelector` descendant) to refocus.
 */
export const useRestoreFocus = <T extends HTMLElement>(
  isEditorOpen: boolean,
  focusSelector?: string,
): RefObject<T> => {
  const targetRef = useRef<T>(null);
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (isEditorOpen) {
      wasOpenRef.current = true;
      return;
    }
    if (!wasOpenRef.current) {
      return;
    }
    wasOpenRef.current = false;
    const target = focusSelector
      ? targetRef.current?.querySelector<HTMLElement>(focusSelector)
      : targetRef.current;
    target?.focus();
  }, [isEditorOpen, focusSelector]);

  return targetRef;
};
